import { useEffect, useState } from 'react';
import { useSparks } from '../../contexts/SparksContext';
import { getLeaderboard } from '../../api/sparksApi';
import { boardClimb, boardSnapshot, setTallyBoard } from './recapTally';

// The final award lands after the screen appears (the completion reply, then the streak reload), so the board is
// re-read once the lifetime total has been still for this long.
export const RANK_SETTLE_MS = 1500;

/**
 * `{ climb, checked }`: the Sparks Stars news since `tally` opened (see recapTally.boardClimb), or null, and whether
 * the board has been read at least once (true straight away when there is no board to compare). With `rebase`, the
 * end board becomes the tally's new starting board, so a mid-lesson screen and the final recap never show the same
 * move twice.
 */
export default function useSparksStarsClimb(childId, tally, { rebase = false } = {}) {
  const { enabled, lifetime } = useSparks();
  const [climb, setClimb] = useState(null);
  const [checked, setChecked] = useState(false);
  const comparable = enabled && !!tally?.board;

  useEffect(() => {
    if (!comparable) return undefined;
    let cancelled = false;
    const t = setTimeout(() => {
      getLeaderboard(childId)
        .then((board) => {
          if (cancelled) return;
          setClimb(boardClimb(tally.board, board));
          if (rebase) setTallyBoard(childId, tally.at, boardSnapshot(board));
        })
        .catch(() => {})
        .finally(() => {
          if (!cancelled) setChecked(true);
        });
    }, RANK_SETTLE_MS);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [comparable, childId, tally, lifetime, rebase]);

  return { climb, checked: checked || !comparable };
}
